// extracted by mini-css-extract-plugin
export default {"root":"WgQXXC6PEsxNWV1Zotx2","bullet":"RS3rHKLuWG_x6FpqeRFM","value":"Fi1jDVEPJpwLzRjr5j71"};